const getThresholdValueAllergies = (level) => {
  switch (level) {
    case 0:
      return {
        threshold: 'No Data',
        color: '#6D6F70',
        OutlineColor: '#7D7F81',
      }
    case 1:
      return {
        threshold: 'Very Low',
        color: '#218371',
        OutlineColor: '#FFFFFF',
      }
    case 2:
      return {
        threshold: 'Relatively Low',
        color: '#6CB2A2',
        OutlineColor: '#0D5E4F',
      }
    case 3:
      return {
        threshold: 'Relatively Moderate',
        color: '#FFFFF0',
        OutlineColor: '#AD8D01',
      }
    case 4:
      return {
        threshold: 'Relatively High',
        color: '#FB8D7B',
        OutlineColor: '#990000',
      }
    case 5:
      return {
        threshold: 'Very High',
        color: '#C40000',
        OutlineColor: '#FFFFFF',
      }

    default:
      return {
        threshold: 'Very High',
        color: '#C40000',
        OutlineColor: '#FFFFFF',
      }
  }
}

export default getThresholdValueAllergies
